import { render } from "./ChangeTypeScreen.vue?vue&type=template&id=6e94685e"
import script from "./ChangeTypeScreen.vue?vue&type=script&lang=js"
export * from "./ChangeTypeScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__